import { Program, Function } from "./program";
import { Module, ExpressionRef, TypeRef } from "./module";
import { Type, Signature, typesToRefs } from "./types";

let startFunctionInstance: Function;
let userApplyFunctionInstance: Function;

// 缓存 start 函数
export function setStartFunctionInstance(f: Function) {
  startFunctionInstance = f;
}

// 缓存用户写的 apply 函数
export function setUserApplyFunctionInstance(f: Function) {
  userApplyFunctionInstance = f;
}

// 生成新的 apply 函数，并且导出
export function callStartBeforeApply(program: Program, module: Module) {
  console.log('---fuck....')
  if (!startFunctionInstance || !userApplyFunctionInstance) {
    throw new Error('[myfish] callStartBeforeApply: start or apply not found');
  }
  const externalName = 'apply';
  const internalName = `~myfish/${externalName}`;
  const signature = new Signature(program, [], Type.void);
  const instance = program.makeNativeFunction(internalName, signature);
  const body = new Array<ExpressionRef>();
  body.push(module.call(startFunctionInstance.internalName, null, TypeRef.None))
  body.push(module.call(userApplyFunctionInstance.internalName, null, TypeRef.None))
  instance.finalize(module, module.addFunction(
    internalName,
    signature.paramRefs,
    signature.resultRefs,
    typesToRefs(instance.additionalLocals),
    module.flatten(body),
  ));
  if (module.hasExport(externalName)) {
    module.removeExport(externalName);
  }
  module.addFunctionExport(internalName, externalName); 
}
